export function getView(patient_id, appointment_id, selected_patient_id) {
  return (patient_id || appointment_id) && selected_patient_id
}
